import { SidebarTrigger } from "@/components/ui/sidebar";
import { TalentureLogo } from "./TalentureLogo";
import { Menu } from "lucide-react";

export function MobileHeader() {
  return (
    <header className="flex md:hidden items-center justify-between px-4 py-3 border-b border-base-gray-200 bg-background sticky top-0 z-40">
      <div className="flex items-center gap-3">
        <SidebarTrigger data-testid="mobile-menu-trigger">
          <Menu className="h-5 w-5" />
        </SidebarTrigger>
        <TalentureLogo />
      </div>
    </header>
  );
}
